export const JOB_TYPES = {
  Hardware:  { label: "Hardware",  color: "blue"   },
  Software:  { label: "Software",  color: "indigo" },
  Network:   { label: "Network",   color: "sky"    },
  Unknown:   { label: "Unknown",   color: "slate"  },
};

export const STATUS_COLORS = {
  Active:    "green",
  Inactive:  "red",
  Pending:   "yellow",
  Unknown:   "slate",
  Completed: "blue",
};

export const THEME_KEY = "ict_theme";
export const SIDEBAR_OPEN_KEY = "ict_sidebar_open";
